import { render, staticRenderFns } from "./AdminPlace.vue?vue&type=template&id=3284a806&"
import script from "./AdminPlace.vue?vue&type=script&lang=js&"
export * from "./AdminPlace.vue?vue&type=script&lang=js&"
import style0 from "./AdminPlace.vue?vue&type=style&index=0&id=3284a806&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports